/*eslint-disable */
import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute
} from 'amazon-cognito-identity-js'
import { Config, CognitoIdentityCredentials } from 'aws-sdk'

export default class Cognito {
  configure(config) {
    if (config.userPool) {
      this.userPool = config.userPool
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId
      })
    }
    Config.region = config.region
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId
    })
    this.options = config
  }

  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, '$cognito', {
      get() {
        return this.$root._cognito
      }
    })

    Vue.mixin({
      beforeCreate() {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito
          this._cognito.configure(options)
        }
      }
    })
  }

  /**
   * username, password
   * username = email
   */
  signUp(username, password) {
    const dataEmail = { Name: 'email', Value: username }
    const attributeList = []
    attributeList.push(new CognitoUserAttribute(dataEmail))
    return new Promise((resolve, reject) => {
      this.userPool.signUp(
        username,
        password,
        attributeList,
        null,
        (err, result) => {
          if (err) {
            reject(err)
          } else {
            resolve(result)
          }
        }
      )
    })
  }

  confirmation(username, confirmationCode) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(confirmationCode, true, (err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  /**
   * username, password
   */
  login(username, password) {
    return new Promise((resolve, reject) => {
      const authenticationDetails = new AuthenticationDetails({
        Username: username,
        Password: password
      })

      const cognitoUser = new CognitoUser({
        Username: username,
        Pool: this.userPool
      })

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => {
          let logins = {}
          logins[
            'cognito-idp.' +
              this.options.region +
              '.amazonaws.com/' +
              this.options.UserPoolId
          ] = result.getIdToken().getJwtToken()
          console.log(logins)
          window.localStorage.setItem('username', username)
          Config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: this.options.UserPoolId,
            Logins: logins
          })
          if (result.accessToken !== undefined) {
            console.log(result)
            // return true
          }
          // this.onChange(true)
          return resolve({ newPasswordRequired: false, result, logins })
        },
        onFailure: err => {
          return reject(err)
        },
        newPasswordRequired: (userAttributes, requiredAttributes) => {
          userAttributes.username = cognitoUser.username
          delete userAttributes.email_verified
          return resolve({
            newPasswordRequired: true,
            attributes: userAttributes,
            session: cognitoUser.Session
          })
        }
      })
      // cognitoUser.getUserAttributes(function(err, result) {
      //   if (err) {
      //     alert(err)
      //     return
      //   }
      //   for (i = 0; i < result.length; i++) {
      //     console.log(
      //       'attribute ' +
      //         result[i].getName() +
      //         ' has value ' +
      //         result[i].getValue()
      //     )
      //   }
      // })
    })
  }

  /**
   * FORCE_CHANGE_PASSWORD
   */
  forceChangePassword(username, password, newpassword) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    const authenticationData = { Username: username, Password: password }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    console.log(authenticationDetails)
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        newPasswordRequired: function(userAttributes, requiredAttributes) {
          cognitoUser.completeNewPasswordChallenge(newpassword, null, {
            onFailure: function(err) {
              console.log(err)
              reject(err)
            },
            onSuccess: function(result) {
              resolve(result)
            }
          })
        }
      })
    })
  }

  confirmPassword(username, password, confirmationCode) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    const authenticationData = { Username: username, Password: password }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    console.log(authenticationDetails)
    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(confirmationCode, password, {
        onFailure(err) {
          console.log(err)
        },
        onSuccess() {
          console.log('Success')
          resolve()
        }
      })
    })
  }

  /*
   *
   */
  sendKey(username) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.resendConfirmationCode(function(err, result) {
        if (err) {
          console.log(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  forgotPassword(username) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.forgotPassword({
        onSuccess: function(result) {
          console.log('call result: ' + result)
          resolve(result)
        },
        onFailure: function(err) {
          console.log(err)
        }
      })
    })
  }

  getUserAttributes(username) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      //
    })
  }

  logout() {
    this.userPool.getCurrentUser().signOut()
  }

  isAuthenticated() {
    const cognitoUser = this.userPool.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (cognitoUser === null) {
        reject(cognitoUser)
      }
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err)
        } else {
          if (!session.isValid()) {
            reject(session)
          } else {
            resolve(session)
          }
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/cognito/cognito.js